<div class="loader" *ngIf="isLoader">
  <img src="assets/images/loader.gif" />
</div>
<div *ngIf="!isLoader">
  <div class="main-header">
    <div class="content-main">
      <div class="logo">
        <a routerLink="/">Calendar</a>
      </div>
      <div class="right-content">
        <div class="dropdown">
          <div class="calendar-header">
            <select [(ngModel)]="selectedState" (ngModelChange)="onStateChange()" class="form-select">
              <option value="">Select a state</option>
              <option *ngFor="let state of states" [value]="state.code">{{ state.name }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="main-container">
    <div class="banner-container">
      <img src="assets/images/banner.jpg" alt="Banner Image" />
    </div>
    <div class="sub-section">
      <div class="calendar-container">
        <app-date-dropdown [months]="months" [currentYear]="currentYear"
          (onMonthChange)="onMonthChange($event)"></app-date-dropdown>

        <div *ngIf="months && months.length">
          <mat-calendar [startAt]="selectedMonth"  [(selected)]="selectedDate" [dateClass]="holidayDateClass"
            (selectedChange)="onDateSelect($event)">
            <div mat-calendar-header>
            </div>
          </mat-calendar>
        </div>
      </div>
      <div class="additional-section">
        <div *ngIf="selectedDate" style="display: flex;flex-direction: column;">
          <h4 style="font-weight: 600;">{{SelDate}}</h4>
          <h4 style="font-weight: 500;">{{SelMonth}} {{SelYear}}</h4>
          <p style="background-color: #eaebefe7; padding: 15px 15px;border-radius: 5px;" *ngIf="holiday_exist">{{ selectedDateReason }}</p>
        </div>

      </div>
    </div>
  </div>

</div>